import React from 'react';
import { HeroBannerSection } from 'shared-types';

interface HeroBannerEditorProps {
    section: HeroBannerSection;
    onChange: (newSection: HeroBannerSection) => void;
}

const EditorRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
    <div>
        <label className="text-sm font-medium text-slate-600 dark:text-slate-400">{label}</label>
        <div className="mt-1">{children}</div>
    </div>
);

const TextInput: React.FC<{ value: string; onChange: (e: React.ChangeEvent<HTMLInputElement>) => void }> = ({ value, onChange }) => (
    <input type="text" value={value} onChange={onChange} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm" />
);

const HeroBannerEditor: React.FC<HeroBannerEditorProps> = ({ section, onChange }) => {

    const handleContentChange = (field: keyof HeroBannerSection['content'], value: string) => {
        onChange({ ...section, content: { ...section.content, [field]: value } });
    };

    return (
        <div className="space-y-4">
            <EditorRow label="Title"><TextInput value={section.content.title} onChange={e => handleContentChange('title', e.target.value)} /></EditorRow>
            <EditorRow label="Subtitle"><TextInput value={section.content.subtitle} onChange={e => handleContentChange('subtitle', e.target.value)} /></EditorRow>
            <div className="grid grid-cols-2 gap-4">
                <EditorRow label="CTA Text"><TextInput value={section.content.ctaText} onChange={e => handleContentChange('ctaText', e.target.value)} /></EditorRow>
                <EditorRow label="CTA Link"><TextInput value={section.content.ctaLink} onChange={e => handleContentChange('ctaLink', e.target.value)} /></EditorRow>
            </div>
            <EditorRow label="Background Image URL"><TextInput value={section.content.backgroundImageUrl} onChange={e => handleContentChange('backgroundImageUrl', e.target.value)} /></EditorRow>
        </div>
    );
};

export default HeroBannerEditor;